var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 50,
    viewBox: "0 0 21 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 18H3.84375C3.65469 18 3.5 18.2438 3.5 18.5417V30.4583C3.5 30.7563 3.65469 31 3.84375 31H5.90625C6.09531 31 6.25 30.7563 6.25 30.4583V18.5417C6.25 18.2438 6.09531 18 5.90625 18ZM5.5625 21H4.1875V20.1667H5.5625V21Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 18H0.375C0.16875 18 0 18.2438 0 18.5417V30.4583C0 30.7563 0.16875 31 0.375 31H2.625C2.83125 31 3 30.7563 3 30.4583V18.5417C3 18.2438 2.83125 18 2.625 18ZM2.25 21H0.75V20.1667H2.25V21Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56398 18.4446L6.45208 19.2207C6.25849 19.2919 6.18094 19.5701 6.27976 19.839L10.2323 30.594C10.3311 30.8629 10.5703 31.0247 10.7639 30.9535L12.8758 30.1774C13.0694 30.1062 13.147 29.828 13.0482 29.5592L9.09562 18.8041C8.99681 18.5352 8.75757 18.3735 8.56398 18.4446ZM9.16237 21.145L7.76256 21.6455L7.52271 21.0468L8.93064 20.5294L9.16237 21.145Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyClasses);
export default __webpack_public_path__ + "static/media/MyClasses.cbefb66d40c62efac7c5aea20a6c5daa.svg";
export { ForwardRef as ReactComponent };